import React, { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase';
import styles from './App.module.css';

import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
// import Articles from './components/Articles';
import Login from './components/Admin/Login';
import AdminDashboard from './components/Admin/AdminDashboard';
import { ToastProvider } from './context/ToastContext';
import WhyWorkWithUs from './components/WhyWorkWithUs';
import HowWeWork from './components/HowWeWork';
import SEOAuthoritySection from './components/SeoModule/SEOAuthoritySection';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import IndustrialPage from './Industrialpage';
import ConsultingPage from './components/ConsultingPage';
import LedgerLockPage from './LedgerLockPage';
import FloatingLedgerLock from './components/FloatingLedgerLock';
import ParticleNetwork from './components/ParticleNetwork';


function PrivateRoute({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser || null);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading) return null;
  return user ? children : <Navigate to="/login" />;
}

function MainWebsite({ darkMode, toggleDarkMode }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [user, setUser] = useState(null);

  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const howwework = useRef(null);
  const contactRef = useRef(null);

  const scrollTo = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return unsubscribe;
  }, []);

  return (
    <div className={styles.container}>
      <ParticleNetwork />

      <div className={styles.overlay}></div>

      <nav className={styles.navbar}>
        <div className={styles.hamburger} onClick={() => setIsMobileMenuOpen(prev => !prev)}>
          ☰
        </div>

        {/* ── Division pills: always visible on ALL screen sizes, never collapses ── */}
        <div className={styles.divisionBar}>
          <Link to="/industrial" className={styles.industrialBtn}>
            Industrial
          </Link>
          <Link to="/consulting" className={styles.consultingBtn}>
            Consulting
          </Link>
          <Link to="/ledgerlock" className={styles.ledgerBtn}>
            LedgerLock
          </Link>
        </div>

        <div className={`${styles.navLinks} ${isMobileMenuOpen ? styles.showMenu : ''}`}>
          <Link onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); setIsMobileMenuOpen(false); }}>Home</Link>
          <Link onClick={() => scrollTo(servicesRef)}>Services</Link>
          <Link onClick={() => scrollTo(howwework)}>How we work</Link>
          <Link onClick={() => scrollTo(aboutRef)}>Work with us</Link>
          <Link onClick={() => scrollTo(contactRef)}>Contact</Link>

          {user && <Link to="/admin">Admin</Link>}
          {user && (
            <>
              <span className={styles.userInfo}>{user.displayName || user.email}</span>
              <button className={styles.authButton} onClick={() => signOut(auth)}>Logout</button>
            </>
          )}
        </div>
      </nav>

      <div className={styles.content}>
        <Hero />
        <div ref={aboutRef}><About /></div>
        <div ref={servicesRef}><Services /></div>
        <div ref={howwework}><HowWeWork /></div>
        <Testimonials />
        <SEOAuthoritySection />
        <div ref={aboutRef}><WhyWorkWithUs /></div>
        <Faq />
        <div ref={contactRef}><Contact /></div>
      </div>

      <Footer isLoggedIn={!!user} />
    </div>
  );
}

function App() {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('theme') === 'dark');

  useEffect(() => {
    document.body.className = darkMode ? 'dark-mode' : '';
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode((prev) => !prev);

  return (
    <ToastProvider>
      <Router>
        <FloatingLedgerLock />
        <Routes>
          <Route path="/" element={<MainWebsite darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
          <Route path="/industrial" element={<IndustrialPage />} />
          <Route path="/consulting" element={<ConsultingPage />} />
          <Route path="/ledgerlock" element={<LedgerLockPage />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;

// // src/App.js
// import React, { useEffect, useState, useRef } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
// import { onAuthStateChanged, signOut } from 'firebase/auth';
// import { auth } from './firebase';
// import styles from './App.module.css';

// import Hero from './components/Hero';
// import About from './components/About';
// import Services from './components/Services';
// import Contact from './components/Contact';
// import Footer from './components/Footer';
// // import Articles from './components/Articles';
// import Login from './components/Admin/Login';
// import AdminDashboard from './components/Admin/AdminDashboard';
// import { ToastProvider } from './context/ToastContext';
// import WhyWorkWithUs from './components/WhyWorkWithUs';
// import HowWeWork from './components/HowWeWork';
// import SEOAuthoritySection from './components/SeoModule/SEOAuthoritySection';
// import IndustrialPage from './Industrialpage';  // ← NEW
// import ConsultingPage from './components/ConsultingPage';  // - NEW


// function PrivateRoute({ children }) {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
//       setUser(currentUser || null);
//       setLoading(false);
//     });
//     return unsubscribe;
//   }, []);

//   if (loading) return null;
//   return user ? children : <Navigate to="/login" />;
// }

// function MainWebsite({ darkMode, toggleDarkMode }) {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [user, setUser] = useState(null);

//   const aboutRef = useRef(null);
//   const servicesRef = useRef(null);
//   const howwework = useRef(null);
//   const contactRef = useRef(null);

//   const scrollTo = (ref) => {
//     if (ref.current) {
//       ref.current.scrollIntoView({ behavior: 'smooth' });
//       setIsMobileMenuOpen(false);
//     }
//   };

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
//       setUser(currentUser);
//     });
//     return unsubscribe;
//   }, []);

//   return (
//     <div className={styles.container}>
//       <video className={styles.backgroundVideo} autoPlay loop muted playsInline>
//         <source src={require('./assets/background.mp4')} type="video/mp4" />
//       </video>

//       <div className={styles.overlay}></div>

//       <nav className={styles.navbar}>
//         <div className={styles.hamburger} onClick={() => setIsMobileMenuOpen(prev => !prev)}>
//           ☰
//         </div>
//         <div className={`${styles.navLinks} ${isMobileMenuOpen ? styles.showMenu : ''}`}>
//           <Link onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Home</Link>
//           <Link onClick={() => scrollTo(servicesRef)}>Services</Link>
//           <Link onClick={() => scrollTo(howwework)}>How we work</Link>
//           <Link onClick={() => scrollTo(aboutRef)}>Work with us</Link>
//           <Link onClick={() => scrollTo(contactRef)}>Contact</Link>

//           {/* ── BETA Edge Industrial CTA ── */}
//           <Link to="/industrial" className={styles.industrialBtn}>
//             ⬡ Industrial
//           </Link>

//           {/* ── BETA Edge Consulting CTA ── */}
//           <Link to="/consulting" className={styles.consultingBtn}>
//             ◈ Consulting
//           </Link>


//           {user && <Link to="/admin">Admin</Link>}
//           {user && (
//             <>
//               <span className={styles.userInfo}>{user.displayName || user.email}</span>
//               <button className={styles.authButton} onClick={() => signOut(auth)}>Logout</button>
//             </>
//           )}
//         </div>
//       </nav>

//       <div className={styles.content}>
//         <Hero />
//         <div ref={aboutRef}><About /></div>
//         <div ref={servicesRef}><Services /></div>
//         <div ref={howwework}><HowWeWork /></div>
//         <SEOAuthoritySection />
//         <div ref={aboutRef}><WhyWorkWithUs /></div>
//         <div ref={contactRef}><Contact /></div>
//       </div>

//       <Footer isLoggedIn={!!user} />
//     </div>
//   );
// }

// function App() {
//   const [darkMode, setDarkMode] = useState(() => localStorage.getItem('theme') === 'dark');

//   useEffect(() => {
//     document.body.className = darkMode ? 'dark-mode' : '';
//     localStorage.setItem('theme', darkMode ? 'dark' : 'light');
//   }, [darkMode]);

//   const toggleDarkMode = () => setDarkMode((prev) => !prev);

//   return (
//     <ToastProvider>
//       <Router>
//         <Routes>
//           <Route path="/" element={<MainWebsite darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/admin" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
//           <Route path="/industrial" element={<IndustrialPage />} />  {/* ← NEW */}
//            <Route path="/consulting" element={<ConsultingPage />} />
//         </Routes>
//       </Router>
//     </ToastProvider>
//   );
// }

// export default App;

